import { render, staticRenderFns } from "./DepartmentVueSelect.vue?vue&type=template&id=6c50e7b2&scoped=true&"
import script from "./DepartmentVueSelect.vue?vue&type=script&lang=js&"
export * from "./DepartmentVueSelect.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentVueSelect.vue?vue&type=style&index=0&id=6c50e7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50e7b2",
  null
  
)

export default component.exports